import WorldMap from "./world-map.png"
const Map = () => {
    return (
        <>
            <div className="max-w-full mx-auto p-6 lg:px-12 lg:py-8 grid lg:grid-cols-2 justify-between items-start text-zinc-800 dark:text-zinc-200">
                <div className="flex flex-col justify-start space-y-6 lg:w-10/12">
                    <h2 className="text-3xl lg:text-4xl text-zinc-900 dark:text-white">We are <span className="text-purple-600 dark:text-purple-400 uppercase font-semibold">Global</span></h2>
                    <p className="text-sm font-light text-zinc-600 dark:text-zinc-400">We have a global footprint. We work with different brands across the world, and our team is diverse with different cultures.</p>
                </div>
            </div>
            <div className='flex w-full mx-auto px-12 py-12 text-zinc-800 dark:text-zinc-200 text-sm justify-center'>
                <img src={WorldMap} alt="World Map" className='w-102 opacity-80 dark:opacity-90 dark:invert-0 invert transition-all duration-300'></img>
            </div>
        </>
    )
}

export default Map